import { baseRoute } from '../../constants/routes';

export const LEADER_BOARD_SETTINGS_PUT_ROUTE = baseRoute + '/leaderboard-settings';
export const LEADER_BOARD_SETTINGS_GET_ROUTE = baseRoute + '/quizlocalization';
export const LEADER_BOARD_SETTINGS_QUIZ_ROUTE = baseRoute + '/quizlocalizations/last';

export const LEADER_BOARD_GET_SETTINGS = 'LEADER_BOARD_GET_SETTINGS';
export const LEADER_BOARD_GET_SETTINGS_SUCCESS = 'LEADER_BOARD_GET_SETTINGS_SUCCESS';
export const LEADER_BOARD_PUT_SETTINGS = 'LEADER_BOARD_PUT_SETTINGS';
export const LEADER_BOARD_PUT_SETTINGS_SUCCESS = 'LEADER_BOARD_PUT_SETTINGS_SUCCESS';
export const LEADER_BOARD_SETTINGS_QUIZ = 'LEADER_BOARD_SETTINGS_QUIZ';
export const LEADER_BOARD_SETTINGS_QUIZ_SUCCESS = 'LEADER_BOARD_SETTINGS_QUIZ_SUCCESS';
